import * as dayjs from 'dayjs'
import { mapCaretakerQualification } from '../../nursingHome.mapper'
import { ContractType, ProfessionalProfile } from '../professionalSelection.model'
import {
  ProfessionalSelectionSearchService,
  ProfessionalSelectionSearchServiceDto,
} from './professionalSelectionSearch.model'

const mapContractType = (contractType: string): ContractType => {
  return contractType as ContractType
}

const mapCaretaker = (
  requestDto: ProfessionalSelectionSearchServiceDto['availableCaretakerRequests'][0],
): ProfessionalSelectionSearchService['caretakers'][0] => {
  return {
    id: requestDto.caretakerId,
    userId: requestDto.caretakerUserId,
    requestId: requestDto.requestId,
    name: requestDto.caretakerName,
    telephone: requestDto.caretakerTelephone,
    email: requestDto.caretakerEmail,
    image: requestDto.caretakerProfileImage,
    qualification: mapCaretakerQualification(requestDto.mainQualification),
    isSelected: requestDto.hasBeenSelected,
  }
}

const mapProfessionalProfiles = (
  isForNurse: boolean,
  isForAuxiliaryNurse: boolean,
  isForPatientCareTechnician: boolean,
): ProfessionalProfile[] => {
  const profiles: ProfessionalProfile[] = []

  if (isForNurse) profiles.push(ProfessionalProfile.nurse)
  if (isForAuxiliaryNurse) profiles.push(ProfessionalProfile.auxiliaryNurse)
  if (isForPatientCareTechnician) profiles.push(ProfessionalProfile.patientCareTechnician)

  return profiles
}

export const mapProfessionalSelectionSearchServiceList = (
  serviceListDto: ProfessionalSelectionSearchServiceDto[],
): ProfessionalSelectionSearchService[] => {
  return serviceListDto.map(
    (serviceDto: ProfessionalSelectionSearchServiceDto): ProfessionalSelectionSearchService => ({
      ref: serviceDto.serviceId,
      contractType: mapContractType(serviceDto.contractType),
      contractStartDate: dayjs(serviceDto.startDate).toDate(),
      caretakers: serviceDto.availableCaretakerRequests.map(request => mapCaretaker(request)),
      contractInfo: serviceDto.information,
      location: serviceDto.institutionName,
      city: serviceDto.location,
      professionalProfiles: mapProfessionalProfiles(
        serviceDto.isForNurse,
        serviceDto.isForAuxiliaryNurse,
        serviceDto.isForPatientCareTechnician,
      ),
      otherProfiles: serviceDto.otherProfile,
      handler: serviceDto.requestedByInstitutionManager,
      numberOfAvailableCaretakers: serviceDto.numberOfAvailableCaretakers,
    }),
  )
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/professionalSelection/professionalSelectionSearch/professionalSelectionSearch.mapper.ts